document.querySelectorAll('[data-bed-product]').forEach(async root => {
  const variants = JSON.parse(root.querySelector('[data-bed-variants]').textContent);
  const statusRoot = root.querySelector('[data-swyft-status]');
  const response = await fetch(statusRoot.dataset.stockUrl);
  if (!response.ok) return;
  const stock = await response.json();
  const selects = [...root.querySelectorAll('[data-bed-option]')];
  const mainImage = root.querySelector('.gp-bed-main-image');
  const showImage = src => { if (!src || !mainImage) return; mainImage.removeAttribute('srcset'); mainImage.src = src; };
  const update = () => {
    const variant = variants.find(v => v.options.every((value, i) => value === selects[i].value));
    const button = root.querySelector('button[name="add"]');
    if (!variant) { button.disabled = true; return; }
    const compare = root.querySelector('[data-bed-compare]');
    if (compare) { compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = variant.compare_at_price ? new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(variant.compare_at_price / 100) : ''; }
    const state = stock[String(variant.id)];
    if (!state) { button.disabled = true; return; }
    root.querySelector('input[name="id"]').value = variant.id;
    root.querySelector('[data-bed-price]').textContent = new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(variant.price / 100);
    if (variant.featured_image?.src) showImage(variant.featured_image.src);
    const date = state.date ? new Date(state.date + 'T12:00:00Z').toLocaleDateString('en-GB', {day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}) : '';
    const message = root.querySelector('[data-stock-message]');
    message.textContent = state.status === 'out' ? statusRoot.dataset.out : state.status === 'preorder' ? statusRoot.dataset.preorder.replace('[date]',date) : '';
    message.hidden = !message.textContent;
    root.querySelector('[data-bed-material]').textContent = state.material || '';
    button.disabled = state.status === 'out';
    button.textContent = state.status === 'out' ? statusRoot.dataset.out : state.status === 'preorder' ? statusRoot.dataset.prebutton : statusRoot.dataset.add;
    const form = button.form;
    let property = form.querySelector('[data-preorder-date]');
    if (state.status === 'preorder') {
      if (!property) { property = document.createElement('input'); property.type='hidden';property.name='properties[Pre-order delivery from]';property.dataset.preorderDate='';form.append(property); }
      property.value = date;
    } else if (property) property.remove();
  };
  selects.forEach(select => select.addEventListener('change', update));
  root.querySelectorAll('[data-bed-image]').forEach(button => button.addEventListener('click', () => showImage(button.dataset.bedImage)));
  update();
});

